/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";
import Area from "../components/Area.jsx";
import { displayModuleType } from "../ModuleType";

export default class AreaBased extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = { loaded: false, areaList: [] };
  }

  componentDidMount = () => {
    Promise.all([
      this.props.service.moduleList[0].areaPlanId
        ? fetch(
            `/services/area_plan_areas?areaPlanId=${this.props.service.moduleList[0].areaPlanId}`,
            {
              headers: {
                "content-type": "application/json",
              },
              method: "GET",
              credentials: "include",
            },
          )
            .then((res) => res.json())
            .then((areaPlanResponse) => {
              const areaList = areaPlanResponse.response.AreaList;
              this.setState({ areaList });
            })
            .catch((err) => console.error(err))
        : {},
      this.props.service.moduleList[0].mobileAreaPlanId
        ? fetch(
            `/services/area_plan_areas?areaPlanId=${this.props.service.moduleList[0].mobileAreaPlanId}`,
            {
              headers: {
                "content-type": "application/json",
              },
              method: "GET",
              credentials: "include",
            },
          )
            .then((res) => res.json())
            .then((areaPlanResponse) => {
              const mobileAreaList = areaPlanResponse.response.AreaList;
              this.setState({ mobileAreaList });
            })
            .catch((err) => console.error(err))
        : {},
      this.props.service.moduleList[0].postcdAreaPlanId
        ? fetch(
            `/services/area_plan_areas?areaPlanId=${this.props.service.moduleList[0].postcdAreaPlanId}`,
            {
              headers: {
                "content-type": "application/json",
              },
              method: "GET",
              credentials: "include",
            },
          )
            .then((res) => res.json())
            .then((areaPlanResponse) => {
              const postcdAreaList = areaPlanResponse.response.AreaList;
              this.setState({ postcdAreaList });
            })
            .catch((err) => console.error(err))
        : {},
    ]).then(() => {
      this.setState({ loaded: true });
    });
  };

  componentWillUnmount = () => {};

  getServiceNumbers = () => {
    const ddiList = this.props.service.ddiList.map((o, i) => {
      return (
        <SectionItem key={i} itemKey="">
          <p className={o.supplierId === 3 ? "auroraNumber" : ""}>
            {o.ddi}
            {o.serviceTypeDescription
              ? ` (${o.serviceTypeDescription})`
              : o.serviceTypeDescription}
          </p>
        </SectionItem>
      );
    });
    return <span>{ddiList}</span>;
  };

  areaOptions = (service) => {
    const areaOptionList = service.moduleList
      .filter((o) => o.moduleType === "AREA_PLAN")
      .map((o, i) => {
        return (
          <SummaryItem key={i} itemKey={`${o.name}:`}>
            <Area
              areaModule={o}
              sites={this.props.sites}
              renderContent={this.props.renderContent}
              areaPlans={this.state.areaList}
              mobileAreaPlans={this.state.mobileAreaList}
              postcdAreaPlans={this.state.postcdAreaList}
            />
          </SummaryItem>
        );
      });
    return <span>{areaOptionList}</span>;
  };

  boltOns = (service) => {
    const boltOnList = service.moduleList
      .filter((o) => o.moduleType !== "AREA_PLAN")
      .filter((o) => typeof displayModuleType[o.moduleType] === "string")
      .sort((a, b) =>
        a.moduleType < b.moduleType ? -1 : a.moduleType > b.moduleType ? 1 : 0,
      )
      .map((o, i) => {
        return (
          <SectionItem key={i} itemKey="">
            {displayModuleType[o.moduleType]}{" "}
          </SectionItem>
        );
      });
    return <span>{boltOnList}</span>;
  };

  enhancedBoltOns = (service) => {
    const boltOnList = service.moduleList
      .filter((o) => o.moduleType !== "AREA_PLAN")
      .filter((o) => typeof displayModuleType[o.moduleType] !== "string")
      .sort((a, b) =>
        a.moduleType < b.moduleType ? -1 : a.moduleType > b.moduleType ? 1 : 0,
      )
      .map((o) =>
        displayModuleType[o.moduleType](
          o,
          this.props.sites,
          this.props.clientId,
        ),
      );
    return <span>{boltOnList}</span>;
  };

  render = () => {
    const { service } = this.props;
    return (
      this.state.loaded && (
        <div
          className={`ui-layout-content content serviceConfig-container ${this.props.isSubLevel ? "subServiceConfig-container" : ""}`}
        >
          <div className="section-body">
            <SectionItem itemKey="Service Name">{service.name}</SectionItem>
          </div>
          {service.ddiList.length > 0 && (
            <SummaryItem itemKey="Number(s):">
              {this.getServiceNumbers()}
            </SummaryItem>
          )}
          {this.areaOptions(service)}
          {service.moduleList
            .filter((o) => o.moduleType !== "AREA_PLAN")
            .filter((o) => typeof displayModuleType[o.moduleType] !== "string")
            .length > 0 && this.enhancedBoltOns(service)}
          {service.moduleList
            .filter((o) => o.moduleType !== "AREA_PLAN")
            .filter((o) => typeof displayModuleType[o.moduleType] === "string")
            .length > 0 && (
            <SummaryItem itemKey="Other additional features: ">
              {this.boltOns(service)}
            </SummaryItem>
          )}
        </div>
      )
    );
  };
}

AreaBased.propTypes = {
  jwt: PropTypes.string,
  service: PropTypes.array,
  sites: PropTypes.object,
  serviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isSubLevel: PropTypes.bool,
  renderContent: PropTypes.func,
};
